module.exports = __webpack_public_path__ + "static/media/camera.94405e23.png";